import { render, staticRenderFns } from "./GemeosCollapse.vue?vue&type=template&id=727fa872&scoped=true&"
import script from "./GemeosCollapse.vue?vue&type=script&lang=js&"
export * from "./GemeosCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fa872",
  null
  
)

export default component.exports